import { useContext } from 'react';
import { FundsContext, FundsContextType } from '.';

export const useFunds = (): FundsContextType => {
    const context = useContext(FundsContext);
    if (!context) {
        throw new Error('useFunds must be used within a FundsProvider');
    }
    return context;
};
